import HotelSearchBarInput from '@domain/hotel/searchBar/dateSelection/HotelSearchBarInput';
import {
  formatMomentDate,
  getCurrentDate,
  isInclusivelyAfterDay,
} from '@utils/dateUtil';
import { CalendarIcon, DownArrowIcon } from '@assets/icons/';
import CustomIcon from '@components/utils/CustomIcon';
import SingleDatePicker from '@components/DatePicker/SingleDatePicker/SingleDatePicker';
import FlightSearchBarInput from '@domain/flight/searchBar/dateSelection/FlightSearchBarInput';
import CarRentalSearchbarInput from '@domain/carRental/searchBar/home/dateSelection/CarRentalSearchBarInput';

import SearchBarInput from '../../SearchBarInput';
import { SearchBarSingleDatePickerInputProps } from './SearchBarSingleDatePickerInputInterface';

type InputComponentsType =
  | 'shopAndFlyHomePageCarRental'
  | 'shopAndFlyHomePageFlight'
  | 'shopAndFlyHomePageHotel'
  | 'setur';

const InputComponents = {
  shopAndFlyHomePageCarRental: CarRentalSearchbarInput,
  shopAndFlyHomePageFlight: FlightSearchBarInput,
  shopAndFlyHomePageHotel: HotelSearchBarInput,
  setur: SearchBarInput,
};
const SearchBarSingleDatePickerInput: React.FC<
  SearchBarSingleDatePickerInputProps
> = ({
  dateProps: { date, onDateChange, ...otherDateProps },
  popoverProps: { onVisibleChange, ...otherPopoverProps } = {},
  error,
  inputComponent,
  ...otherProps
}) => {
  const dateString = formatMomentDate(date);
  const { containerStyle, ...restPopoverProps } = otherPopoverProps;

  const InputComponent = InputComponents[inputComponent as InputComponentsType];

  return (
    <InputComponent
      leftIcon={() => (
        <CustomIcon
          fontSize={28}
          paletteColor='primaryBrand'
          icon={CalendarIcon}
        />
      )}
      rightIcon={() => (
        <CustomIcon
          icon={DownArrowIcon}
          fontSize={16}
          paletteColor='blackAlpha'
        />
      )}
      error={error}
      InputComponent={dateString || otherProps.placeholder}
      popoverProps={{
        onVisibleChange,
        ...restPopoverProps,
        containerStyle: {
          ...containerStyle,
          boxShadow: 'none',
        },
      }}
      renderOverlayContent={(closePopup) => {
        return (
          <SingleDatePicker
            onDateChange={(date) => {
              onDateChange(date);
            }}
            isOutsideRange={(day) =>
              !isInclusivelyAfterDay(day, getCurrentDate())
            }
            initialVisibleMonth={null}
            date={date}
            onClose={closePopup}
            {...otherDateProps}
            useDesktopSearchbarFooter
          />
        );
      }}
      {...otherProps}
    />
  );
};

export default SearchBarSingleDatePickerInput;
